<template>
  <div>

<h2 class="goth">Imperfekt av starka verb</h2>
<div class="grammatikparagrafbredd leftorient">


              <div class="quasi-p p-stil">I imperfekt av <div class="understryk">starka verb</div> används

              <div class="understryk"><nobr> [imperfekt-stam] + imperfektändelser</nobr></div>.</div>
                  <p>Hur verbstammen i imperfekt ser ut är olika från verb till verb och måste därför
                  läras in separat för varje starkt verb.</p>


                  <p class="grammatikparagrafbredd leftorient">Här ett exempel på imperfekt med verbet <i>gehen</i> vars
                  imperfektstam är <i>ging</i></p>


                  <table class="">
                  <br>

                  <tr class="leftorient">
                    <td  class="ljusgra">ich</td>
                    <td  class="ljusgra"><i>ging<b></b></i></td>
                  </tr>

                  <tr class="leftorient">
                    <td  class="ljusgra">du</td>
                    <td  class="ljusgra"><i>ging<b>st</b></i></td>
                  </tr>

                  <tr class="leftorient">
                    <td  class="ljusgra">er<br> es<br> sie</td>
                    <td  class="ljusgra"><i>ging<b></b></i></td>
                  </tr>

                  <td></td>
                  <tr class="leftorient">
                    <td  class="ljusgra upperspace">wir</td>
                    <td  class="ljusgra"><i>ging<b>en</b></i></td>
                  </tr>

                  <tr class="leftorient">
                    <td  class="ljusgra">ihr</td>
                    <td  class="ljusgra"><i>ging<b>t</b></i></td>
                  </tr>

                  <tr class="leftorient">
                    <td  class="ljusgra">sie<br> Sie</td>
                    <td  class="ljusgra"><i>ging<b>en</b></i></td>
                  </tr>


                  </table>
<br><br>
                  <p>Här följer några exempel på vanliga starka verb och deras imperfektstammar.</p>

                  <table class="">

                      <tr class="leftorient">
                          <th  class="ljusgra">
                          <th  class="ljusgra">infinitiv</th>
                          <th  class="ljusgra">imperfekt</th>
                      </tr>

                      <tr class="leftorient">
                          <td  class="ljusgra">få</td>
                          <td  class="ljusgra"><i>bekommen</i></td>
                          <td  class="ljusgra"><i><div class="minitext">er </div> <b> bekam</b></i></td>
                      </tr>

                      <tr class="leftorient">
                          <td  class="ljusgra">äta</td>
                          <td  class="ljusgra"><i>essen</i></td>
                          <td  class="ljusgra"><i><div class="minitext">er </div><b> aß</b></i></td>
                      </tr>

                      <tr class="leftorient">
                          <td  class="ljusgra">finna</td>
                          <td  class="ljusgra"><i>finden</i></td>
                          <td  class="ljusgra"><i><div class="minitext">er </div><b> fand</b></i></td>
                      </tr>

                      <tr class="leftorient">
                          <td  class="ljusgra">gå</td>
                          <td  class="ljusgra"><i>gehen</i></td>
                          <td  class="ljusgra"><i><div class="minitext">er </div><b> ging</b></i></td>
                      </tr>



                      <tr class="leftorient">
                          <td  class="ljusgra">läsa</td>
                          <td  class="ljusgra"><i>lesen</i></td>
                          <td  class="ljusgra"><i><div class="minitext">er </div><b> las</b></i></td>
                      </tr>

                      <tr class="leftorient">
                          <td  class="ljusgra">ta</td>
                          <td  class="ljusgra"><i>nehmen</i></td>
                          <td  class="ljusgra"><i><div class="minitext">er </div><b> nahm</b></i></td>
                      </tr>


                      <tr class="leftorient">
                          <td  class="ljusgra">prata</td>
                          <td  class="ljusgra"><i>sprechen</i></td>
                          <td  class="ljusgra"><i><div class="minitext">er </div><b> sprach</b></i></td>
                      </tr>

                      <tr class="leftorient">
                          <td  class="ljusgra">sova</td>
                          <td  class="ljusgra"><i>schlafen</i></td>
                          <td  class="ljusgra"><i><div class="minitext">er </div><b> schlief</b></i></td>
                      </tr>

                      <tr class="leftorient">
                          <td  class="ljusgra">skriva</td>
                          <td  class="ljusgra"><i>schreiben</i></td>
                          <td  class="ljusgra"><i><div class="minitext">er </div><b> schrieb</b></i></td>
                      </tr>

                      <tr class="leftorient">
                          <td  class="ljusgra">se</td>
                          <td  class="ljusgra"><i>sehenen</i></td>
                          <td  class="ljusgra"><i><div class="minitext">er </div><b> sah</b></i></td>
                      </tr>

                      <tr class="leftorient">
                          <td  class="ljusgra">bära</td>
                          <td  class="ljusgra"><i>tragenen</i></td>
                          <td  class="ljusgra"><i><div class="minitext">er </div><b> trug</b></i></td>
                      </tr>

                      <tr class="leftorient">
                          <td  class="ljusgra">träffa</td>
                          <td  class="ljusgra"><i>treffen</i></td>
                          <td  class="ljusgra"><i><div class="minitext">er </div><b> traf</b></i></td>
                      </tr>

                      <tr class="leftorient">
                          <td  class="ljusgra">dricka</td>
                          <td  class="ljusgra"><i>trinken</i></td>
                          <td  class="ljusgra"><i><div class="minitext">er </div><b> trank</b></i></td>
                      </tr>

                      <tr class="leftorient">
                          <td  class="ljusgra">glömma</td>
                          <td  class="ljusgra"><i>vergessen</i></td>
                          <td  class="ljusgra"><i><div class="minitext">er </div> <b> vergaß</b></i></td>
                      </tr>

                      <tr class="leftorient">
                          <td  class="ljusgra">tvätta</td>
                          <td  class="ljusgra"><i>waschen</i></td>
                          <td  class="ljusgra"><i><div class="minitext">er </div><b> wusch</b></i></td>
                      </tr>


                  </table>



<br><br>

</div>

<br>
</div>


</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},
metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "imperfekt starka verb"
            }
        ]
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
